import EventTokenListAPI from './event-token-list-api';

export default EventTokenListAPI;
